/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './general-overview.scss';

/* eslint-disable import/no-unresolved, import/default */

import pageTemplate from './general-overview.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.generalOverview', [])
    .directive('agGeneralOverview', GeneralInformation)
    .name;

/*@ngInject*/
function GeneralInformation() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: GeneralOverviewController,
        controllerAs: 'vm',
        templateUrl: pageTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function GeneralOverviewController($scope, $filter, $translate, $q, $log, types, agTypes, agUtils, siloService, unitService, userService, alarmService, attributeService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloId = null;
    vm.cropType = null;
    vm.cropLabel = 'N/A';
    vm.fansStatus = 'N/A';
    vm.alarmsStatus = 'N/A';
    vm.activeAlarms = 0;
    vm.staleAlarms = 0;

    vm.aerations = [];
    vm.latestFanValuesSubscriptionOptions = {
      callbacks: {
        onDataUpdated: onFansUpdated,
        onDataUpdateError: onDataUpdateError,
        dataLoading: function() {}
      },
      useDashboardTimewindow: false
    };

    agUtils.getCropNames().then(
        (response) => {
            vm.cropNames = [];
            var cropNames = response.jsonValue;
            for (var property in cropNames) {
                var cropNameObj = {};
                cropNameObj.nameId = property;
                cropNameObj.value = cropNames[property];
                vm.cropNames.push(cropNameObj);
            }
        }
    );

    function onFansUpdated(subscription, apply) {
      loadFansState();
      if (apply) {
        $scope.$digest();
      }
    }

    function onDataUpdateError(subscription, e) {
      $log.error(e);
    }

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;
            vm.siloId = null;

            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSiloInformation();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        loadSiloInformation();
                    }
                }
            );
        }
    });

    $scope.$on('$destroy', function() {
      reset();
    });

    $scope.$on('alarmsUpdated', function() {
      loadAlarmsState();
    });

    function loadAlarmsState() {
      vm.activeAlarms = 0;
      vm.staleAlarms = 0;

      if (vm.siloId) {
        fetchAlarms(vm.siloId, types.alarmStatus.activeUnack).then((alarms) => {
          vm.activeAlarms = alarms.data.length;
        });
        fetchAlarms(vm.siloId, types.alarmStatus.activeAck).then((alarms) => {
          vm.staleAlarms = alarms.data.length;
        });
      }
    }

    function loadFansState() {
      vm.fansStatus = 'N/A';
      if (vm.siloId) {

        vm.fansStatus = vm.aerations.length > 0 ? $translate.instant('ag.aeration.off') : "N/A";

        for (let aerationIndex in vm.aerations) {
          const aeration = vm.aerations[aerationIndex];
          attributeService.getEntityLatestTimeseriesValues(aeration.id.entityType, aeration.id.id, [agTypes.telemetry.aeration.state], { ignoreLoading: true }).then(
              (aerationResponse) => {
                if (aerationResponse.state.length > 0 && aerationResponse.state[0].value === 'on') {
                  vm.fansStatus = $translate.instant('ag.aeration.on');
                }
              }
          );
        }
      }
    }

    function initFansSubscriptions() {
      reset();

      if (vm.siloId) {
        siloService.getSiloConnectedSystems(vm.siloId).then(
            function success(connectedSystems) {
              vm.aerations = connectedSystems ?? [];

              const latestValuesSubscriptionsInfo = [];
              for (let aerationIndex in vm.aerations) {
                const aeration = vm.aerations[aerationIndex];

                latestValuesSubscriptionsInfo.push({
                  type: types.datasourceType.entity,
                  entityType: types.entityType.asset,
                  entityId: aeration.id.id,
                  entityName: aeration.name,
                  timeseries: [
                    {name: vm.agTypes.telemetry.aeration.state}
                  ]
                });
              }

              vm.ctx.subscriptionApi.createSubscriptionFromInfo(
                  types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestFanValuesSubscriptionOptions, false, true).then(
                  function(subscription) {
                    vm.latestValuesSubscription = subscription;
                  }
              );
            }
        );
      }
    }

    function loadCropData() {
      vm.cropType = null;
      vm.cropLabel = 'N/A';

      if (vm.siloId) {
        attributeService.getEntityLatestTimeseriesValues(vm.siloId.entityType, vm.siloId.id, [agTypes.telemetry.silo.cropType], { ignoreLoading: true }).then(
            (cropResponse) => {
              vm.cropType = null;
              const cropType = cropResponse.crop_type[0].value;
              if (vm.cropNames) {
                var currentCropName = $filter('filter')(vm.cropNames, {nameId: cropType}, true);
                if (currentCropName && currentCropName.length) {
                  vm.cropType = currentCropName[0];
                }
                vm.cropLabel = vm.cropType ? $translate.instant(agTypes.cropNames[vm.cropType.value.name]) : "N/A";
              }
            }
        );
      }
    }

    function loadSiloInformation() {
        vm.alarmsStatus = 'N/A';

        if (vm.siloId) {
            vm.loading = true;
            siloService.getSilo(vm.siloId).then(
                function success(silo) {

                    vm.alarmsStatus = silo.disableAlarms ? $translate.instant('ag.generalInfo.disabled') : $translate.instant('ag.generalInfo.enabled');
                    loadAlarmsState();
                    loadCropData();
                    initFansSubscriptions();

                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function fetchAlarms(entityId, status) {
        var deferred = $q.defer();
        alarmService.getAlarms(entityId.entityType, entityId.id, { limit: 1000 }, null, status, true).then(
            (alarmsObj) => {
                deferred.resolve(alarmsObj);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function reset() {
      vm.aerations = [];
      if (vm.latestValuesSubscription) {
        vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
      }
    }
}
